import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Suppliers',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/logistic',
      },
      {
        text: 'Suppliers',
        href: '/adm/logistic/suppliers',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: '',
    sortDesc: false,
    fields: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'address',
        label: 'Address',
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Phone',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_choose_supplier: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'company',
        label: 'Company',
        sortable: true,
      },
      {
        key: 'email',
        label: 'Email',
      },
      {
        key: 'phone',
        label: 'Phone',
      },
    ],
    detail: false,
    form: {
      code: '',
      company: '',
      company_group: '',
      address: '',
      city: '',
      province: '',
      country: '',
      postal_code: '',
      email: '',
      phone: '',
      fax: '',
      currency: 'IDR',
      due_date: 30,
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeSupplier(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchSupplier(context, params = null) {
    let result = await ApiGetRequest(`logistic/suppliers`, params);
    return !result.error ? result.data.object : [];
  },

  async getListSupplier({ commit, state }) {
    commit('changeSupplier', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`logistic/suppliers`, params);
    commit('changeSupplier', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailSupplier({ commit, state }, payload = null) {
    commit('changeSupplier', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`logistic/suppliers/${payload.id}`);
    commit('changeSupplier', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async importData({ commit, state, dispatch }) {
    commit('changeSupplier', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`logistic/suppliers/import`, {
      items: data.import_form || [],
    });
    commit('changeSupplier', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createSupplier({ commit, state, dispatch }) {
    commit('changeSupplier', {
      loading: true,
    });

    let result = await ApiPostRequest(`logistic/suppliers`, state.data.form);
    commit('changeSupplier', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateSupplier({ commit, state, dispatch }, payload = null) {
    commit('changeSupplier', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `logistic/suppliers/${payload.id}`,
      state.data.form
    );

    commit('changeSupplier', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteSupplier({ commit, dispatch }, payload = null) {
    commit('changeSupplier', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`logistic/suppliers/${payload.id}`);
    commit('changeSupplier', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
